// extracted by mini-css-extract-plugin
export default {"modal__body":"otp-modal_modal__body__YAIjR"};